import { Flex, Text, Box, Divider } from '@chakra-ui/react';
import { ReactComponent as CopyIcon } from 'assets/copy-icon.svg';
import { ReactNode } from 'react';

interface DetailRowProps {
  label: string;
  value: ReactNode;
  onCopy?: () => void;
  action?: ReactNode;
  isLast?: boolean;
  wordBreak?: 'break-all' | 'break-word';
}

const DetailRow = ({ label, value, onCopy, action, isLast, wordBreak }: DetailRowProps) => (
  <>
    <Flex py={2} px={1} alignItems="flex-start" justifyContent="space-between" gap={3}>
      <Text size="xs" color="blackAlpha.600" whiteSpace="nowrap" mt="2px" minW="80px">
        {label}
      </Text>
      <Flex flex={1} alignItems="center" justifyContent="flex-start" gap={2} minW={0}>
        <Box
          textAlign="left"
          wordBreak={wordBreak}
        >
          {typeof value === 'string' ? (
            <Text size="sm" variant="bodyNormal">
              {value}
            </Text>
          ) : (
            value
          )}
        </Box>
        {onCopy && (
          <CopyIcon
            cursor="pointer"
            style={{ flexShrink: 0 }}
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              onCopy();
            }}
          />
        )}
        {action}
      </Flex>
    </Flex>
    {!isLast && <Divider borderColor="gray.100" />}
  </>
);

export default DetailRow;
